import { getSafeInternalRedirectPath } from './getSafeInternalRedirectPath';

const STORAGE_KEY = 'auth.pendingLogoutRedirect';

export const consumePendingLogoutRedirect = (): string | undefined => {
  const storedPath = window.sessionStorage.getItem(STORAGE_KEY);
  window.sessionStorage.removeItem(STORAGE_KEY);

  return getSafeInternalRedirectPath(storedPath);
};
